"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const mobx_react_1 = require("mobx-react");
const Filters_happyjoe_1 = require("./Elements/Filters-happyjoe");
const ProductBox_1 = require("./Elements/ProductBox");
const Store_1 = require("./Store");
const ContentArea_1 = require("./Elements/ContentArea");
let ProductList = class ProductList extends React.Component {
    componentDidMount() {
        Store_1.default.siteName = "Happy Joe";
        document.title = Store_1.default.currentPageName + " | " + Store_1.default.siteName;
        Store_1.default.updateNavigationColor(Store_1.default.containerId);
    }
    render() {
        let backgroundImageUrl = "";
        let dimFilter = false;
        let headerText = Store_1.default.Translations.headerText.toUpperCase();
        let ingressText = Store_1.default.Translations.ingressText;
        let categoryContainerId = 0;
        if (Store_1.default.SelectedCategories.length > 0) {
            categoryContainerId = Store_1.default.SelectedCategories[0].id;
            backgroundImageUrl = Store_1.default.SelectedCategories[0].backgroundImageUrl;
            dimFilter = Store_1.default.SelectedCategories[0].dimFilter;
            if (!backgroundImageUrl) {
                backgroundImageUrl = Store_1.default.BackgroundImageUrl;
                dimFilter = Store_1.default.DimFilter;
            }
            if (Store_1.default.SelectedCategories[0].categoryHeader && Store_1.default.SelectedCategories[0].categoryHeader.length > 0) {
                headerText = Store_1.default.SelectedCategories[0].categoryHeader.toUpperCase();
            }
            if (Store_1.default.SelectedCategories[0].categoryIngress && Store_1.default.SelectedCategories[0].categoryIngress.length > 0) {
                ingressText = Store_1.default.SelectedCategories[0].categoryIngress;
            }
        }
        else {
            backgroundImageUrl = Store_1.default.BackgroundImageUrl;
            dimFilter = Store_1.default.DimFilter;
        }
        let hasBgImage = backgroundImageUrl && backgroundImageUrl.length > 0;
        let bgStyle = React.createElement("style", null);
        let filterStyle = {};
        if (hasBgImage) {
            filterStyle.backgroundColor = 'black';
            filterStyle.opacity = 0.25;
            bgStyle = React.createElement("style", { dangerouslySetInnerHTML: {
                    __html: `@media all and (max-width: 600px) {
                   .product-listing-background-image {
                       background-image: url('${backgroundImageUrl}?width=800&CropMode=percentage&crop=18,0,18,0');
                       background-size: cover;
                       background-repeat: no-repeat;
                   }
                 }
                 @media all and (min-width: 601px) and (max-width: 1024px) {
                    .product-listing-background-image {
                        background: url('${backgroundImageUrl}?width=1024');
                        background-size: cover;
                        background-repeat: no-repeat;
                    }
                }
                @media all and (min-width: 1025px) {
                    .product-listing-background-image {
                        background: url('${backgroundImageUrl}?width=1200');
                        background-size: cover;
                        background-repeat: no-repeat;
                    }
               }`
                } });
            window.addFullWidth();
        }
        else {
            window.removeFullWidth(false);
        }
        return (React.createElement(React.Fragment, null,
            hasBgImage && bgStyle,
            hasBgImage &&
                React.createElement("div", { className: "row u-pt-10 _md-u-pt-20 u-relative product-listing-background-image" },
                    dimFilter && React.createElement("div", { className: "s-bg-cover background-image", style: filterStyle }),
                    React.createElement("div", { className: "col-lg-12 col-sm-12 col-xs-12 u-z-1" },
                        React.createElement("div", { className: "o-container u-full-width" },
                            React.createElement(Filters_happyjoe_1.default, { headerText: headerText, ingressText: ingressText })))),
            React.createElement("div", { className: "o-container" },
                !hasBgImage &&
                    React.createElement(Filters_happyjoe_1.default, { headerText: headerText, ingressText: ingressText }),
                Store_1.default.SelectedBrand !== null &&
                    React.createElement("div", { className: "o-brand-banner" },
                        React.createElement("div", { style: { backgroundImage: "url(" + Store_1.default.SelectedBrand.imageUrl + ")" } },
                            React.createElement("h1", { className: "u-mx-0" }, Store_1.default.SelectedBrand.name)),
                        React.createElement("h2", { className: "s-h2" }, Store_1.default.SelectedBrand.ingress)),
                React.createElement("div", { className: "o-product-listing-wrapper" },
                    Store_1.default.loading &&
                        React.createElement("div", { className: "ui active inverted dimmer" },
                            React.createElement("div", { className: "ui text loader" }, Store_1.default.Translations.loadingText)),
                    React.createElement("div", { className: "row u-pb-12" }, Store_1.default.Products && Store_1.default.Products.map(function (product, index) {
                        return (React.createElement(ProductBox_1.default, { key: product.id, product: product }));
                    })))),
            categoryContainerId > 0 &&
                React.createElement(ContentArea_1.default, { content: categoryContainerId, language: Store_1.default.currentLanguage, area: "BottomContentArea" }),
            categoryContainerId <= 0 &&
                React.createElement(ContentArea_1.default, { content: Store_1.default.containerId, language: Store_1.default.currentLanguage, area: "ProductContentArea" })));
    }
};
ProductList = __decorate([
    mobx_react_1.observer
], ProductList);
exports.default = ProductList;
